import React from "react";

import Card from "../../../../components/Card";

type BaseReviewCycleDetailsCardProps = Parameters<typeof Card>[0] & {
	width: "normal" | "wide";
};

const BaseReviewCycleDetailsCard = ({
	children,
	className,
	width,
	style,
	padding = "16px",
	...props
}: BaseReviewCycleDetailsCardProps) => {
	const cardStyle = { border: "1px solid var(--py-neutral-2)", ...style };

	// Note - Tailwind doesn't like dynamic width classes
	if (width === "normal") {
		return (
			<Card
				border
				className={`w-max-[288px] h-[130px] w-[288px] shrink bg-neutral-2 ${className}`}
				padding={padding}
				style={cardStyle}
				{...props}
			>
				{children}
			</Card>
		);
	} else if (width === "wide") {
		return (
			<Card
				border
				className={`w-max-[400px] h-[130px] w-[400px] shrink bg-neutral-2 ${className}`}
				padding={padding}
				style={cardStyle}
				{...props}
			>
				{children}
			</Card>
		);
	} else {
		throw new Error(`Invalid width: ${width}`);
	}
};

export default BaseReviewCycleDetailsCard;
